if (!customElements.get('bozhi-card-buy')) {
  customElements.define('bozhi-card-buy', class extends HTMLElement {
    connectedCallback() {
      if (this.bound) return;
      this.bound = true;
      this.trigger = this.querySelector('button.bozhi-card-buy__trigger');
      this.choices = this.querySelector('.bozhi-card-buy__choices');
      if (!this.trigger || !this.choices) return;
      this.card = this.closest('.bozhi-card');
      this.events = new AbortController();
      const options = { signal: this.events.signal };
      this.trigger.addEventListener('click', () => this.setOpen(this.choices.hidden), options);
      this.card.addEventListener('pointerenter', event => {
        if (event.pointerType === 'mouse' && matchMedia('(hover: hover)').matches) this.setOpen(true);
      }, options);
      this.card.addEventListener('pointerleave', event => {
        if (event.pointerType === 'mouse' && !this.contains(document.activeElement)) this.setOpen(false);
      }, options);
      this.addEventListener('keydown', event => {
        if (event.key === 'Escape') {
          event.preventDefault();
          this.setOpen(false);
          this.trigger.focus();
        }
      }, options);
      this.addEventListener('focusout', event => {
        // Keep the picker open while focus moves from the icon to a variant.
        if (event.relatedTarget && this.contains(event.relatedTarget)) return;
        queueMicrotask(() => {
          if (!this.contains(document.activeElement) && !this.card.matches(':hover')) this.setOpen(false);
        });
      }, options);
      document.addEventListener('pointerdown', event => {
        if (!this.contains(event.target)) this.setOpen(false);
      }, options);
    }
    disconnectedCallback() {
      this.events?.abort();
      this.bound = false;
    }
    setOpen(open) {
      this.choices.hidden = !open;
      this.trigger.setAttribute('aria-expanded', String(open));
      this.classList.toggle('is-open', open);
    }
  });
}
